import React from 'react';
import ShopItem from './shop-item';
const createShopItems = (shopItemList) => {
    return shopItemList.map((shopItem) => {
        return React.createElement(ShopItem, { shopItem: shopItem, key: shopItem.shop_name });
    });
};
const ShopItemGroup = ({ shopItemList }) => {
    return (React.createElement("div", { className: "shop-item-group" }, createShopItems(shopItemList)));
};
export default ShopItemGroup;
